import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meta: {
    pageNumber: 1,
    pageSize: 20,
    itemTotal: 0,
  },
  list: [],
  reports: [],
  selectedClient: {
    client: {
      _id: undefined,
    },
    files: [],
  },
  clientAdded: false,
  clientUpdated: false,
  clientRemoved: false,
};

const clientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    getClients(state, action) {
      state.list = action.payload.client;
      state.meta = action.payload.meta;
    },
    getClientsById(state, action) {
      state.selectedClient = action.payload;
    },
    addClients(state, action) {
      state.clientAdded = true;
    },
    updateClients(state, action) {
      state.clientUpdated = true;
    },
    removeClients(state, action) {
      state.clientRemoved = true;
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const clientsActions = clientsSlice.actions;
export default clientsSlice;
